import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Center Column - Logo & Links */}
          <div className="footer-column center-column">
            <div className="brand-section">
              <div className="logo-container">
                <img src="./logo.png" alt="DX Rider Logo" className="logo-img" />
              </div>
              
              {/* Links in a row below logo */}
              <div className="footer-links-row">
                <a href="/privacy-policy" className="footer-link">
                  Privacy Policy
                </a>
                <span className="link-separator">|</span>
                <a href="/terms-and-conditions" className="footer-link">
                  Terms & Conditions
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Footer Divider */}
        <div className="footer-divider"></div>
        
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="copyright">
            <p className="copyright-text">
              © {currentYear} DX RIDER. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;